import client from './client';

export async function getSubscriptionStatus() {
  const response = await client.get('/subscription/status');
  return response.data;
}

export async function createCheckout() {
  const response = await client.post('/subscription/checkout');
  return response.data;
}

export async function openBillingPortal() {
  const response = await client.post('/subscription/portal');
  return response.data;
}

export async function cancelSubscription() {
  const response = await client.post('/subscription/cancel');
  return response.data;
}

export async function resumeSubscription() {
  const response = await client.post('/subscription/resume');
  return response.data;
}
